<template>
  <div class="message__text">
    <div class="message__content">
      <span v-html="messageHTML"></span>
    </div>
    <div
      v-if="showOverflowButton"
      @click="showMore"
      class="message__button"
      role="button"
    >
      {{ $t("chat.more") }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    message: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      hideLargeText: true,
    };
  },
  computed: {
    messageHTML() {
      return this.addHTMLTags(this.messageText);
    },
    messageText() {
      if (this.showOverflowButton) {
        return `${this.capMessage(this.message.text)}...`;
      }

      return this.message.text;
    },
    textOverflows() {
      return this.message.text && this.message.text.length > 500
        && this.message.text.length - 500 > 50;
    },
    showOverflowButton() {
      return this.textOverflows && this.hideLargeText;
    },
  },
  methods: {
    capMessage(str) {
      return str.substring(0, 500);
    },
    showMore() {
      this.hideLargeText = false;
    },
  },
};
</script>
